import React from 'react';
import {
  LoadingPlaceholderComponent,
  MainPageContainer,
  Navbar,
  StepForm,
  StepWrapper,
} from 'components-core';
import {
  MainWrapper,
  OptionWrapper,
  OptionRadio,
  PageTitle,
  OptionTitle,
} from './DefaultLoadingSkeletonStyles';

const Option = () => {
  return (
    <OptionWrapper>
      <OptionRadio>
        <LoadingPlaceholderComponent radius="50%" height="100%" width="100%" />
      </OptionRadio>
      <OptionTitle>
        <LoadingPlaceholderComponent radius="4px" height="100%" width="100%" />
      </OptionTitle>
    </OptionWrapper>
  );
};

const DefaultLoadingSkeleton = ({ numberOfItems, ...rest }) => {
  return (
    <MainPageContainer>
      <Navbar hideCloseIcon hideActions />
      <StepWrapper>
        <PageTitle>
          <LoadingPlaceholderComponent radius="4px" height="100%" width="100%" />
        </PageTitle>
        <StepForm>
          <MainWrapper {...rest}>
            <Option />
            <Option />
            <Option />
          </MainWrapper>
        </StepForm>
      </StepWrapper>
    </MainPageContainer>
  );
};

DefaultLoadingSkeleton.defaultProps = {
  numberOfItems: 3,
};

export default DefaultLoadingSkeleton;
